import script from "./LanguageSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSelector.vue?vue&type=style&index=0&id=3d4db569&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d4db569"]])

export default __exports__